import _ from 'underscore';
import { useCallback, useContext, useMemo } from 'react';
import { odata } from '@bingads-webui/http-util';
import { getConfig } from '@bingads-webui-campaign/odata-config';
import { ServerContext } from '@bingads-webui-campaign-react/mca-server-context';

// reads window.location and returns the odata subpath, e.g. Campaign/V2
const odataConfig = getConfig();

/**
 * Provides a way to make calls to the Campaigns odata API from DMC.
 * E.g. https://ui.ads.microsoft.com/ODataApi/Campaign/V2/Customers(x)/Accounts(y)/Default.Foo
 * @returns {Object} - odata values and functions.
 */
export function useCampaignApiCall() {
  const [serverContext] = useContext(ServerContext);
  const {
    CampaignAPIPath, // this value only exists in CCUI ServerContext
    ServicesEndpoints: {
      CampaignAPI, // path to ODataApi root, should have trailing slash
    },
    Token,
  } = serverContext;

  const odataRoot = useMemo(() => {
    const odataPath = CampaignAPIPath || odataConfig.odataPath;
    return `${CampaignAPI}${odataPath}`;
  }, [CampaignAPI, CampaignAPIPath]);

  const post = useCallback((url, options) => {
    const headers = _.extend({
      Authorization: `CCMTSmallToken ${Token}`,
      'x-ms-lastwritetime': 'Max',
    }, options.headers);

    return odata.post(url, {
      ...options,
      headers,
    });
  }, [Token]);

  return {
    odataRoot,
    post,
    Token,
  };
}
